import { toast } from "sonner";
import { Overline } from "./shared";

const copyUrl = (slug) => {
  navigator.clipboard.writeText(`${window.location.origin}/b/${slug}`).then(
    () => toast.success("URL copied"),
    () => toast.error("Copy failed")
  );
};

const downloadHtml = (r) => {
  const blob = new Blob([r.html], { type: "text/html" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = `${r.slug}.html`;
  a.click();
  URL.revokeObjectURL(a.href);
};

export const WebsiteResult = ({ r }) => (
  <div data-testid="bb-result-website">
    <div className="border border-black bg-[#0a0a0a] text-white p-6 mb-5 flex flex-wrap items-center justify-between gap-4">
      <div>
        <Overline>🚀 Your site is LIVE</Overline>
        <a
          href={`/b/${r.slug}`}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="bb-website-live-link"
          className="font-display font-extrabold text-2xl lg:text-3xl tracking-tight text-white underline decoration-[#ff3b30]"
        >
          universtrend.com/b/{r.slug}
        </a>
      </div>
      <div className="flex gap-3">
        <button
          data-testid="bb-website-copy"
          onClick={() => copyUrl(r.slug)}
          className="border border-white px-4 py-2 overline hover:bg-white hover:text-black"
        >
          Copy URL
        </button>
        <button
          data-testid="bb-website-download"
          onClick={() => downloadHtml(r)}
          className="border border-white bg-[#ff3b30] px-4 py-2 overline"
        >
          Download HTML ↓
        </button>
      </div>
    </div>
    <div className="border border-black">
      <div className="p-3 border-b border-black bg-[#f4f4f5] font-mono text-xs text-[#52525b]">
        Live preview
      </div>
      <iframe
        title="Generated website preview"
        srcDoc={r.html}
        sandbox="allow-same-origin"
        data-testid="bb-website-preview"
        className="w-full h-[560px] bg-white"
      />
    </div>
  </div>
);
